define('component',['jsx'], function (jsx) {

  'use strict';

  var buildMap = {};

  return {
    version: '1.0.1',

    load: function (name, parentRequire, onLoadNative, config) {
      var component;

      var parts;
      var path = '';
      var componentName = name;
      var extension = '';

      if (componentName.indexOf('/') !== -1) {
        parts = componentName.split('/');

        componentName = parts.pop();
        path = parts.join('/') + '/';
      }

      if (componentName.indexOf('-') !== -1) {
        parts = componentName.split('-');

        componentName = parts.shift();
        extension = '-' + parts.join('-');
      }

      component = 'components/' + path + componentName + '/' + componentName + extension;

      var onLoad = {
        error: function (error) {
          onLoadNative.error(error);
        },

        fromText: function (content) {
          if (config.isBuild) {
            buildMap[name] = content;
          }

          onLoadNative.fromText(content);
        }
      };

      config.jsx = {
        fileExtension: '.js',
      };

      jsx.load(component, parentRequire, onLoad, config);
    },

    write: function (pluginName, name, write) {
      if (buildMap.hasOwnProperty(name)) {
        var text = buildMap[name];
        write.asModule(pluginName + "!" + name, text);
      }
    }
  }
});

